// extracted by mini-css-extract-plugin
export default {"selector":"QofPyW","address":"S5nt2A","banner":"e97sYk","label":"hUJ1sC","text":"EneFmx","map":"g2qixS","minOrderPrice":"sQuI6A"};